import Axios from 'axios'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../Components/Button'
import RoundCard from '../../Components/RoundCard'
import Spinner from '../../Components/Spinner'
import config from '../../Shared/config'
import './Teachers.scss'

export default class Teachers extends Component {

    constructor(props) {
        super(props)

        this.state = {
            teachersArray: [],
            teachersFetching: true,
            teachersFetched: false
        }
    }

    componentDidMount() {
        const url = `${config.apiUrl}/Teacher/getall?skip=0&pageSize=5`;
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.setState({
                    teachersArray: res.data.data.listData,
                    teachersFetching: false,
                    teachersFetched: true
                })
            } else {
                alert(res.data.message)
                this.setState({
                    teachersArray: [],
                    teachersFetching: false,
                    teachersFetched: false
                })
            }
        }).catch(err => {
            console.error(err)
            this.setState({
                teachersArray: [],
                teachersFetching: false,
                teachersFetched: false
            })
        })
    }

    render() {
        const { teachersArray, teachersFetching, teachersFetched } = this.state

        return (
            <div className='teachers'>

                <h1>Teachers  <img alt='features' src={'https://www.flaticon.com/svg/static/icons/svg/2436/2436654.svg'}></img></h1>
                {
                    teachersFetching ? (
                        <>
                            <div style={{ padding: '20px 0px' }} className="space"></div>
                            <Spinner />
                            <div style={{ padding: '20px 0px' }} className="space"></div>
                        </>

                    ) : (
                            teachersFetched ? (
                                <>
                                    <div className="cards">
                                        {
                                            teachersArray.map((item, idx) => {
                                                return <Link to={`/teacher/${item._id}`}><TeacherCard key={idx} teacher={item} /></Link>
                                            })
                                        }
                                    </div>

                                    <div className="showmore">
                                        <Link to={'/teachers'}>
                                            <Button variant='primary-light'>Show More</Button>
                                        </Link>
                                    </div>
                                </>
                            ) : null
                        )
                }
            </div>
        )
    }
}

class TeacherCard extends Component {
    render() {
        const { teacher } = this.props
        const teacherDescMaxLength = 150

        return (
            <RoundCard className='teacher-card'>
                <div style={{ backgroundImage: `url(${teacher.profileImageUrl})` }} className="profile-picture"></div>
                <div className="meta">
                    <div className="name">{teacher.firstName || ''} {' '} {teacher.lastName}</div>
                    <div className="username"> {'@' + teacher.userName}</div>
                    <div className="description">
                        {
                            teacher.description ? (teacher.description.length > teacherDescMaxLength ? (`${teacher.description.substring(0, teacherDescMaxLength)}...`) : teacher.description) : ''
                        }
                    </div>
                    <div className="experience">
                        <div className="experience-type">
                            <div className="experience-label">Teaching Experience</div>
                            <div className="experience-value">{teacher.teachingExperience}</div>
                        </div>
                        <div className="experience-type">
                            <div className="experience-label">Practical Experience</div>
                            <div className="experience-value">{teacher.practiceExperience}</div>
                        </div>
                        <div className="experience-type">
                            <div className="experience-label">Number of Students Taught</div>
                            <div className="experience-value">{teacher.numberOfStudentsTaught}</div>
                        </div>
                    </div>
                </div>
            </RoundCard>
        )
    }
}

export {
    TeacherCard
}